import type {FocusedMetaTags} from "./index.js";

/**
 *
 */

if (typeof window !== "undefined") {
  window.addEventListener("load", extractFocusedMetaTags);
  window.addEventListener("popstate", extractFocusedMetaTags);
}

/**
 *
 */
export function extractFocusedMetaTags(): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const isRunningInApp = window.o_apps_android || window.webkit;
  if (!isRunningInApp) return;

  const topBarMetaContent = document.head.querySelector(
    "meta[name=apps-focused-layout-top-bar-visibility]"
  )?.getAttribute("content");

  const bottomBarMetaContent = document.head.querySelector(
    "meta[name=apps-focused-layout-bottom-bar-visibility]"
  )?.getAttribute("content");

  const titleMetaContent = document.head.querySelector(
    "meta[name=apps-focused-layout-title]"
  )?.getAttribute("content");

  const metaJson: FocusedMetaTags = {};
  if (topBarMetaContent === "hidden") {
    metaJson.topBarVisibility = topBarMetaContent;
  }
  if (bottomBarMetaContent === "hidden") {
    metaJson.bottomBarVisibility = bottomBarMetaContent;
  }
  if (titleMetaContent != null && titleMetaContent !== "") {
    metaJson.title = titleMetaContent;
  }

  sendFocusedMetaJson(metaJson);
}

/**
 *
 */
export function sendFocusedMetaJson(metaJson: FocusedMetaTags): void {
  if (typeof window === "undefined") return;

  const isRunningInApp = window.o_apps_android || window.webkit;
  if (!isRunningInApp) return;

  const payload = metaJson;
  window.o_apps_android?.onFocusedMetaTagsReceived?.(JSON.stringify(payload));
  window.webkit?.messageHandlers?.onFocusedMetaTagsReceived?.postMessage(payload)
}
